export const HEALTHY_CONTRIBUTIONS = 'healthycontributions.com';
export const AMERICAN_ARBITRATION_ASSOCIATION = 'https://www.adr.org/Rules';
export const HEALTHY_CONTRIBUTIONS_WWW = 'www.healthycontributions.com';
export const GOOGLE_MAPS_URL = 'https://maps.google.com/?q=';
export const HTTPS_PREFIX = 'https://';